/**
 * Build a compact, readable one-line preview for SQL history.
 *
 * If the first non-empty line is a single token (common after formatting like:
 * `SELECT\n  ...`), concatenate the first 3 non-empty lines into one line.
 */
export function getQueryHistoryPreview(sql: string, maxLength = 80): string {
  const trimmed = sql.trim();
  if (!trimmed) return '';

  const lines = trimmed
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length === 0) return '';

  const firstLine = lines[0];
  const firstLineTokenCount = firstLine.split(/\s+/g).filter(Boolean).length;

  const previewCandidate =
    firstLineTokenCount <= 1 && lines.length > 1
      ? (() => {
          const parts: string[] = [];
          let currentLength = 0;

          for (const line of lines) {
            if (!line) continue;
            const nextLength = currentLength === 0 ? line.length : currentLength + 1 + line.length;
            parts.push(line);
            currentLength = nextLength;
            if (currentLength >= 25) break;
          }

          return parts.join(' ');
        })()
      : firstLine;

  const preview = previewCandidate.replace(/\s+/g, ' ').trim();

  if (preview.length <= maxLength) {
    return preview;
  }

  return preview.slice(0, Math.max(0, maxLength - 3)) + '...';
}
